module.exports = __webpack_public_path__ + "static/devil_align-a00e2e96d99828a8a58df5e4e3c53ccf.png";